export class JobWorkDto {

    id: number;
    name: string;
    isActive: boolean;
    createdUser: string | null;
    createdAt: Date;
    updatedUser: string | null;
    updatedAt: Date;
    versionFlag: number;
    

    constructor(
        id: number,
        name: string,
        isActive: boolean,
        createdUser: string | null,
        createdAt: Date,
        updatedUser: string | null,
        updatedAt: Date,
        versionFlag: number,
        
    ) {
        this.id = id;
        this.name = name;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.createdAt = createdAt;
        this.updatedUser = updatedUser;
        this.updatedAt = updatedAt;
        this.versionFlag = versionFlag;
    }
}
